import * as React from "react";
import { Types } from "@grandvisionhq/graphql";
import { Toggletip } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
import { useLatestDynamicDeliveryEstimation } from "@grandvisionhq/svc-dynamic-delivery-estimation";
import { formatDeliveryDate } from "../../../../../../utils/utils/formatDeliveryDate.js";
import { DeliveryIndicatorModalContainer } from "./DeliveryIndicatorModal.js";
import { DeliveryIndicator } from "../../../../components/modules/DeliveryIndicator/components/DeliveryIndicator.js";
import { useDeliveryIndicator } from "../../../../../../contexts/DeliveryIndicator/contexts/DeliveryIndicator/context.js";
const DynamicDeliveryIndicator = ({
  deliveryItems,
  fallbackLabel,
  view = "full",
  hasRxLens,
  ...rest
}) => {
  const { getLabel, locale } = useIntl();
  const { deliveryInfo } = useDeliveryIndicator();
  const deliveryLabel = getLabel("products.deliveryEstimation.label");
  const transformDeliveryItems = React.useMemo(() => {
    const itemInfo = deliveryItems && deliveryItems.length > 0 ? deliveryItems.map((item) => ({
      sku: item.sku,
      quantity: item.quantity,
      ...hasRxLens ? { bundleLineItemType: Types.BundleLineItemType.PRESCRIPTION_GLASSES } : {}
    })) : [];
    return {
      itemInfo,
      shippingMethodKey: null
    };
  }, [deliveryItems, hasRxLens]);
  const { data, loading, error } = useLatestDynamicDeliveryEstimation({
    queryInputArgs: transformDeliveryItems
  });
  const deliveryMessage = React.useMemo(() => {
    if (data?.earliestDeliveryDate && data?.latestDeliveryDate) {
      return `${deliveryLabel} ${formatDeliveryDate(
        locale,
        data?.earliestDeliveryDate
      )} - ${formatDeliveryDate(locale, data?.latestDeliveryDate)}`;
    }
    if (data?.earliestDeliveryDate) {
      return `${deliveryLabel} ${formatDeliveryDate(locale, data?.earliestDeliveryDate)}`;
    }
    return "";
  }, [data, deliveryLabel, locale]);
  const tooltipSlot = deliveryInfo ? /* @__PURE__ */ React.createElement(DeliveryIndicatorModalContainer, null) : /* @__PURE__ */ React.createElement(Toggletip, { message: getLabel("products.deliveryIndicator.deliveryTooltip") });
  return /* @__PURE__ */ React.createElement(
    DeliveryIndicator,
    {
      deliveryMessage,
      isLoading: loading,
      hasError: !!error,
      view,
      fallbackLabel,
      tooltipSlot,
      ...rest
    }
  );
};
export {
  DynamicDeliveryIndicator
};
//# sourceMappingURL=DynamicDeliveryIndicator.js.map
